exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/Ivanchis/Documents/Project/app2soft/app2soft-site-development/config/src"],"sourceMap":true}!./src/components/build-your-team-thank-you/style.scss
// module id = 400
// module chunks = 0